import { useAuth } from '../../../auth/useAuth';
import type { ChatbotMemberRole } from '../../../types/chatbot';
import { useChatbotMembersQuery } from '../queries/useChatbotMembersQuery';

export function useCurrentChatbotRole(
  chatbotId: string | undefined,
): ChatbotMemberRole | null {
  const { user } = useAuth();
  const membersQuery = useChatbotMembersQuery(chatbotId);

  if (!user?.id || !membersQuery.data) {
    return null;
  }

  return (
    membersQuery.data.find((member) => member.userId === user.id)?.role ?? null
  );
}
